export default __webpack_public_path__ + "static/media/5252.ebd89ded.png";